





































import gql from 'graphql-tag'
import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppDialogModal from '@/components/AppDialogModal.vue'
import AppEmptyCard from '@/components/AppEmptyCard.vue'
import FeedItem from '@/components/FeedItem.vue'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'
import { Common } from '@/mixins'

@Component({
  components: {
    AppDialogModal,
    AppEmptyCard,
    FeedItem
  },
  apollo: {
    getFeedByFeedId: {
      query: gql`query getFeedByFeedIdAtFeedItemsModal($feedId: Int!) {
        getFeedByFeedId(feedId: $feedId) {
          id
          feedItems {
            id
            type
            comment
            item {
              ...ItemTileFragment
            }
          }
        }
      }
      ${ITEM_TILE_FRAGMENT}`,
      variables () { return { feedId: +this.fromFeedId } },
      result () {
        this.type = this.normalFeedItems.length ? 'NORMAL' : 'ADDITIONAL'
      }
    }
  }
})
export default class extends Mixins(Common) {
  @Prop(String) readonly fromFeedId!: string
  @Prop() readonly segmentItemIds: string[] | undefined

  getFeedByFeedId: { feedItems: { type: string; item: { id: string } }[] } = { feedItems: [] }
  type = ''

  filterBySegmentItemIds (feedItems: { type: string; item: { id: string } }[], segmentItemIds: string[] | undefined) {
    if (segmentItemIds) {
      return feedItems.filter(
        feedItem => segmentItemIds.some(segmentItemId => segmentItemId === feedItem.item.id)
      )
    } else {
      return feedItems
    }
  }

  get feedItems () {
    return this.getFeedByFeedId.feedItems
  }

  get normalFeedItems () {
    const feedItems = this.feedItems.filter(feedItem => feedItem.type === 'NORMAL')
    return this.filterBySegmentItemIds(feedItems, this.segmentItemIds)
  }

  get additionalFeedItems () {
    const feedItems = this.feedItems.filter(feedItem => feedItem.type === 'ADDITIONAL')
    return this.filterBySegmentItemIds(feedItems, this.segmentItemIds)
  }
}
